<template>
  <el-table-column
    :key="field.prop"
    :width="field.width"
    :sortable="field.sortable ? 'custom' : false"
    :label="field.label"
    :prop="field.prop"
  >
    <template slot-scope="scope" class="pull-right">
      <i
        v-if="scope.row[field.prop]"
        class="icon el-icon-circle-check true"
        title="Tak"
      />
      <i v-else class="icon el-icon-circle-close false" title="Nie" />
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    field: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/vars.scss';

.true {
  color: $success-color;
}

.false {
  color: $error-color;
}
</style>
